module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-half acts-wrapper"
  }, [_c('div', {
    staticClass: "document-container columns"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": _vm.deleteItem
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-data"
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Название ссылки"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.object.name),
      callback: function($$v) {
        _vm.$set(_vm.object, "name", $$v)
      },
      expression: "object.name"
    }
  }), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "https://"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.object.url),
      callback: function($$v) {
        _vm.$set(_vm.object, "url", $$v)
      },
      expression: "object.url"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd7ba93e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Information/NormativeActItem.vue
// module id = 1002
// module chunks = 0